var $752a534a8a8281ab$exports = {};
$752a534a8a8281ab$exports = {
    "pending": `En attente`
};


export {$752a534a8a8281ab$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
